
import storage from '@/utils/storage.js'
const mutations = {
  saveUserInfo (state, data) {
    storage.setLocal('token',data.token)
    storage.setLocal('userinfo', data)
    state.adminUser = data
  },
  saveRoute (state, data) {
    state.routes = data
  },
  saveLanguage (state, data) {
    storage.setLocal('localeLaguage', data)
    state.selectLanguage = data.name
    state.elementLanguage = data.txt
  }
}
export default mutations
